export default __webpack_public_path__ + "6b2653e6138b7a6e4dd1d57d92c2377b.svg";